import { isSemrush } from '/src/utils/semrush';

export const DATE_QUERY_PARAM = 'date';
export const SEMRUSH_DATE_QUERY_PARAM = 'd';

export function getQueryParamKeys(key) {
  if (key !== DATE_QUERY_PARAM) {
    return { preferredKey: key, fallbackKey: null };
  }

  if (isSemrush) {
    return { preferredKey: SEMRUSH_DATE_QUERY_PARAM, fallbackKey: DATE_QUERY_PARAM };
  }

  return { preferredKey: DATE_QUERY_PARAM, fallbackKey: SEMRUSH_DATE_QUERY_PARAM };
}
